import * as React from "react";

interface XAxisTickProps {
  x?: number;
  y?: number;
  payload?: { value: string };
  currentSurveyDateString: string | null;
  surveyId?: number;
  onDateClick?: (surveyId: number) => void;
  hoveredDateString?: string | null;
  onDateHover?: (dateStr: string | null) => void;
}

export const XAxisTick: React.FC<XAxisTickProps> = ({
  x,
  y,
  payload,
  currentSurveyDateString,
  surveyId,
  onDateClick,
  hoveredDateString,
  onDateHover,
}) => {
  if (!payload || x == null || y == null) {
    return null;
  }
  const dateValue = payload.value;
  const isCurrentSurvey = currentSurveyDateString === dateValue;
  const isDateHovered = hoveredDateString === dateValue;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent chart onClick from firing
    if (surveyId && onDateClick) {
      onDateClick(surveyId);
    }
  };

  const handleMouseEnter = () => {
    onDateHover?.(dateValue);
  };

  const handleMouseLeave = () => {
    onDateHover?.(null);
  };

  const fillColor = isCurrentSurvey
    ? "var(--neutral-1)"
    : isDateHovered
      ? "var(--neutral-1)"
      : "var(--neutral-4)";

  return (
    <text
      x={x}
      y={y + 16}
      fill={fillColor}
      fontSize={isCurrentSurvey ? "1rem" : "0.75rem"}
      textAnchor="middle"
      fontWeight={isCurrentSurvey ? 700 : 400}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ cursor: surveyId ? "pointer" : "default" }}
    >
      {dateValue}
    </text>
  );
};
